import IWorker from 'models/Worker';

export interface IWorkerData {
  create: {
    config: {
      isLoading: boolean;
    };
  };
  delete: {
    config: {
      isLoading: boolean;
    };
  };
  edit: {
    config: {
      isLoading: boolean;
    };
  };
  getAll: {
    config: {
      emptyMsg: string;
      errorMsg: string;
      isLoading: boolean;
    };
    list: IWorker[];
  };
}

const workerInitialState: IWorkerData = {
  create: {
    config: {
      isLoading: false,
    },
  },
  edit: {
    config: {
      isLoading: false,
    },
  },
  delete: {
    config: {
      isLoading: false,
    },
  },
  getAll: {
    config: {
      isLoading: false,
      emptyMsg: '',
      errorMsg: '',
    },
    list: [],
  },
};
export default workerInitialState;
